import { combineReducers } from "redux";
import filterReducer from "./filters/reducer";
import bookReducer from "./books/reducer";
import {reducer as updateReducer} from "./update";

const rootReducer = combineReducers({
    books: bookReducer,
    filters: filterReducer,
    update: updateReducer,
});

export default rootReducer;